import React from 'react';
import { Box, Fade, Typography } from '@mui/material';

interface TypingIndicatorProps {
  typingUsers: string[];
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ typingUsers }) => {
  if (typingUsers.length === 0) return null;

  const text = typingUsers.length === 1
    ? `${typingUsers[0]} друкує...`
    : `${typingUsers.join(', ')} друкують...`;

  return (
    <Fade in={true}>
      <Box sx={{ display: 'flex', alignItems: 'center', ml: 7, mb: 1, mt: 0.5 }}>
        <div className="typing-dots">
           <span>.</span><span>.</span><span>.</span>
        </div>
        <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
          {text}
        </Typography>
      </Box>
    </Fade>
  );
};
